import React, { useState, useEffect,useContext } from "react";
import {
  Box,
  Image,
  Text,
  Link,
  VStack,
  Button,
  Select,
  Input,
  TextArea,
  CloseIcon,
  Flex,
} from "native-base";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { DESKTOPSIZE, ORG_ID } from "../../constants";
import StyledButton from "../../components/Button";
import StyledImage from "../../components/Image";
import DatePicker from 'react-date-picker';
function PinkYourOutfit() {
  
  const fileInputRef = React.useRef(null);
  const [imageURL, setImageURL] = useState(null);
  const [date, setDate] = useState("");
  const [occasion, setOccasion] = useState("");
  const [value, onChange] = useState(new Date());
const handleImageClick = () => {
  fileInputRef.current.click();
};
  const [service, setService] = React.useState("");
  const location = useLocation();
  const UploadImg = require("./image.png");
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type.match('image.*')) {
      const reader = new FileReader();
      
      reader.onload = (loadEvent) => {
        setImageURL(loadEvent.target.result);
      };
      
      reader.readAsDataURL(file);
    }
  };
  const clearImage = () => {
    setImageURL(null);
  };
  const navigate = useNavigate();
  return (
    <>
      <input
      type="file"
      style={{ display: 'none' }}
      ref={fileInputRef}
      onChange={handleFileChange} // Implement this function to handle the file
    />
          <Flex
            minH={"100vh"}
            direction="column"
            justifyContent={"space-between"}
          >
            <Box>
              <VStack
                alignItems="flex-start"
                space={4}
                px={"4"}
                paddingTop={"4"}
              >
                <Button onPress={() => navigate(-1)} variant={"unstyled"}>
                  <CloseIcon
                      color={'black'}
                    size={"5"}
                  />
                </Button>
              </VStack>
              <VStack
                alignItems={"center"}
                marginBottom={"4"}
                px={4}
                space={"6"}
              >
                <Text
                  color={'black'}
                  fontFamily={'Unna'}
                  fontSize={'28px'}
                  letterSpacing={"0.46px"}
                >
                 Your Outfits
                </Text>
                
              </VStack>
              <VStack
                alignItems={"center"}
                marginBottom={"4"}
                px={4}
                space={"6"}
              >
                <Text
                  color={'#9D7C07'}
                  fontFamily={'Unna'}
                  fontSize={'16px'}
                  letterSpacing={"0.46px"}
                >
                 A Garment for all seasons
                </Text>
                
              </VStack>
              <VStack  alignItems={"center"} px={4} space={"4"} py={"4"}> 
                <Text color={''} fontSize={'14px'} fontFamily={'Unna'} >
                This vest was made to be worn throughout all four seasons, with your own version of an outfit in mind. 
                </Text>
                <Text color={''} fontSize={'14px'} fontFamily={'Unna'} >
                Keep track of your outfits for your own use, or share them with friends.
                </Text>
              </VStack>
              <VStack
                alignItems={"center"}
                marginTop={10}
                px={4}
                space={"6"}
              >
                <Text
                  color={'black'}
                  fontFamily={'Unna'}
                  fontSize={'30px'}
                  letterSpacing={"0.46px"}
                >
                Upload your outfit below
                </Text>
                
              </VStack>
              <VStack alignItems={"center"} marginTop={10} marginBottom={10}>
                <StyledImage
                  width="30%"
                  src={imageURL || UploadImg }
                  alt={"Image of the product design 2"}
                  onClick={handleImageClick}
                />
                 {imageURL && (
          <Box position="absolute" top="4" right="20"  onClick={clearImage}>
            <CloseIcon color="black" size="3" />
          </Box>
        )}
              </VStack>
              <VStack
            alignItems={"left"}
            marginBottom={10}
            px={4}
            space={"6"}
          >
            <Flex alignItems="flex-start">
              <VStack flexDirection={'row'}>
              <Text
                color={'black'}
                fontFamily={'Unna'}
                fontSize={'16px'}
                letterSpacing={"0.46px"}
                mr={51}
              >
              Date:
              </Text>
                    <DatePicker onChange={onChange} value={value} />
              </VStack>
             
            </Flex>
            <Flex alignItems="flex-start">
            <VStack flexDirection={'row'}>
              <Text
                color={'black'}
                fontFamily={'Unna'}
                fontSize={'16px'}
                letterSpacing={"0.46px"}
                mr={5}
              >
              Occasion:
              </Text>
              <TextArea
                w="90%"
                h={20}
                placeholder="Describe the occasion"
                value={occasion}
                onChange={(e) => setOccasion(e.target.value)}
              />
              </VStack>
            </Flex>
          </VStack>
            </Box>
            
          </Flex>
    </>
  );
}
export default PinkYourOutfit;
